import React from "react";

const Footer = () => {
    return (
        <p className="footer-p">Check out the code at <a href="https://github.com/Maherukh/MusikPlayer">✔ My Github Repo</a></p>
    );
};

export default Footer;